import { validation } from './state'

export const getterTypes = {
	files: 'files',
	filesFind: 'filesFind',
	filesFolders: 'filesFolders',
	filesBrands: 'filesBrands',
	filesValidation: 'filesValidation',
	filesGetUri: 'filesGetUri'
};

export default {
	// @depreciated
	[getterTypes.files]: state => state.files,	
	[getterTypes.filesBrands]: state => state.files.filter(temp => temp.folder == 'brands'),	
	[getterTypes.filesGetUri]: state => fileId => state.files.find(temp => temp.id == fileId).uri,

	[getterTypes.filesAll]: state => state.files,	
	[getterTypes.filesFolders]: state => state.folders,	
	[getterTypes.filesFind]: state => id => state.files.find(temp => temp.id == parseInt(id)),
	[getterTypes.filesValidation]: () => validation,
};